import React from 'react'

import { translate } from 'parking-react-common'

import Panel from '../components/Panel'

const EmailVerificationContainer = ({ t }) => (
    <Panel
        title={ t('Confirming Email Address') }
        isLoading
    >
        { t('Please wait..') }
    </Panel>
)

export default translate()(EmailVerificationContainer)
